import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const useSessionUuidParams = (): string | undefined => {
  const params = useParams();
  const sessionUuid = params?.sessionUuid;

  return useMemo(() => {
    return sessionUuid;
  }, [sessionUuid]);
};

export default useSessionUuidParams;
